import React from 'react';
import { string, func, oneOf } from 'prop-types';
import classnames from 'classnames';

export default function Button({ mode, onClick, label }) {
    const rootClassName = classnames('button', {
        [`button--${mode}`]: mode,
    });

    return (
        <button className={rootClassName} onClick={onClick}>
            {label}
        </button>
    );
}

Button.propTypes = {
    mode: oneOf(['discreet-primary']).isRequired,
    label: string,
    onClick: func,
};

Button.defaultProps = {
    label: '',
    onClick: null,
};
